// getCMSSummary

import _ from '@/utils/lodash-optimized'
import React from 'react'
import { connect } from 'react-redux'
import renderHTML from 'react-render-html'
import eoc from 'shared_src/episodeofcare'

import { withLegacyRouter } from '../../../decorators'
import * as Card from '../../shared/card'
import Document from '../../shared/DocumentViewer/document'
import {
  CircularProgress,
  Button,
  Expandable,
  Modal
} from '../../shared/NarusMaterial'
import { encounterSign, encounterGetChanges, getCMSSummary, getAPSReport, getResearchReviewReport } from '../actions'
import { SignEncounterForm } from '../SignEncounter'

import { saveFormState, saveEncounterType } from './actions'
import './styles.scss'

class RenderDoc extends React.Component {
  componentDidMount () {
    const { dispatch, type, reportType, patientId, encounter } = this.props
    if (type === 'cms') {
      if (reportType === 'APS') {
        dispatch(getAPSReport(patientId, encounter.id))
      } else if (reportType === 'Research') {
        dispatch(getResearchReviewReport(patientId, encounter.id))
      } else {
        dispatch(getCMSSummary(patientId, encounter.id))
      }
    } else {
      dispatch(encounterGetChanges(patientId, encounter.id, type))
    }
  }

  render () {
    const { encounterSummaryLoading, encounterSummaryData } = this.props

    if (encounterSummaryLoading) {
      return <CircularProgress />
    }

    return (
      <div
        className='pdf-gutter'
        style={{
          background: '#DDD',
          justifyContent: 'center'
        }}
      >
        <div>
          {encounterSummaryData && (
            <Document
              hasStickyPB
              mime='application/pdf'
              data={encounterSummaryData}
              withScale={false}
            />
          )}
        </div>
      </div>
    )
  }
}

class EncounterSummary extends React.Component {
  constructor (props) {
    super(props)
      const type = props?.encounterSummaryForm?.encounterType
    this.state = {
      openHtml: false,
      type
    }

    this.openHtml = this.openHtml.bind(this)
    this.closeHtml = this.closeHtml.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.renderEncounterSummary = this.renderEncounterSummary.bind(this)
  }

  componentDidMount () {
    this.setState({ type: 'patient' })
  }

  componentWillUnmount () {
    const { dispatch } = this.props
    const { type } = this.state

    dispatch(saveEncounterType(type))
  }

  onSubmit (formData) {
    const { dispatch, encounter: propEncounter, navigate, auth } = this.props
    const encounter = this.signEncounter()
    const data = {
      user: encounter.author_id,
      type: encounter.document.type,
      supervisor: this.props.supervisor,
      medicalDirector: this.props.medicalDirector,
      agentDoNotBill: encounter.document.agentDoNotBill,
      ...formData
    }

    const signingUser = auth.profile.sub !== encounter.author_id ? (auth.profile.given_name + ' ' + auth.profile.family_name) : null
    dispatch(encounterSign(propEncounter, data, navigate, signingUser))
  }

  closeHtml () {
    this.setState({
      openHtml: false
    })
  }

  openHtml () {
    this.setState({
      openHtml: true
    })
  }

  signEncounter () {
    const { encounter } = this.props
      const encounterType = encounter?.document?.type
    const { type } = this.state
    if (encounterType === 'patient') {
      return {
        ...encounter,
        document: {
          ...encounter.document,
          type
        }
      }
    }
    return encounter
  }

  renderHtmlModal () {
    const { openHtml } = this.state
    const { encounterSummaryHtml } = this.props
    const actions = [
      <Button
        key={1}
        onClick={this.closeHtml}
        label='Close'
      />
    ]

    const htmlString = String(encounterSummaryHtml)
    const html = renderHTML(htmlString)

    if (openHtml) {
      return (
        <Modal
          title='Report Html'
          actions={actions}
        >
          {html}
        </Modal>
      )
    }
    return null
  }

  renderEncounterSummary () {
    const {
      caseStatus,
      isPatientDead,
      medicalDirector,
      supervisor,
      userManagingOrg,
      clientOrg,
      clientAttributes,
      isSigning,
      dispatch,
      encounterSummaryForm,
      encountersHistory,
      settings,
      auth: { profile },
      params: { clientName },
      encounter: {
        document: { type: documentEncounterType }
      }
    } = this.props

    const _encounter = this.signEncounter()
      const type = _encounter?.document?.type
    const reportType = localStorage.getItem('reportType')
    const encounter = this.signEncounter()
    const resource = encounter.subject_id
    const path = 'encountersummary'
    const user = localStorage.getItem('asUserId') ? localStorage.getItem('asUserId') : encounter.author_id

    if (type) {
      return (
        <>
          <div className='section'>
            <h2>Preview</h2>
            <Expandable title='Show Report Preview'>
              <RenderDoc
                {...this.props}
                type={type}
                reportType={reportType}
              />
            </Expandable>
          </div>
          <Button
            onClick={this.openHtml}
            label='Open Html'
            style={{
              position: 'absolute',
              top: '-1000px'
            }}
          />
          <SignEncounterForm
            formKey='signEncounter'
            caseStatus={caseStatus}
            isPatientDead={isPatientDead}
            encounter={encounter}
            isSigning={isSigning}
            medicalDirector={medicalDirector}
            supervisor={supervisor}
            profile={profile}
            documentEncounterType={documentEncounterType}
            userManagingOrg={userManagingOrg}
            clientOrg={clientOrg}
            clientAttributes={clientAttributes}
            clientName={clientName}
            onSign={this.onSubmit}
            saveFormState={formState => {
              dispatch(saveFormState(formState))
            }}
            savedFormState={encounterSummaryForm.formState}
            settings={settings}
            encountersHistory={encountersHistory}
            draft={{
              resource,
              path,
              user
            }}
          />
          {this.renderHtmlModal()}
        </>

      )
    }
    return null
  }

  render () {
    const { encounter } = this.props
    if (encounter) {
      return (
        <Card.Card>
          <Card.Header>
            <h2>Encounter Summary</h2>
          </Card.Header>
          <div className='sign-encounter-form'>
            {this.renderEncounterSummary()}
          </div>
        </Card.Card>
      )
    }
    return <CircularProgress />
  }
}

const mapStateToProps = redux => {
    const episodesOfCare = redux?.patient?.compartment?.EpisodeOfCare ?? null


    const clientName = redux?.patient?.clientName
  const clientOrg = _.chain(redux)
    .get('globalVars.clients', [])
    .find(c => c.clientName === clientName)
    .get('organization', '')
    .value()

  const clientAttributes = _.chain(redux)
    .get('globalVars.clients', [])
    .find(c => c.clientName === clientName)
    .get('attributes', '')
    .value()

  const episodeOfCare =
    episodesOfCare && episodesOfCare[Object.keys(episodesOfCare)[0]]

  return {
    caseStatus: episodeOfCare && episodeOfCare.status,
    isPatientDead: episodeOfCare && eoc.dead(episodeOfCare),
    signed: redux.encounter?.signed,
    isSigning: redux.encounter?.encounter?._signing ?? false,
    encounter: redux.encounter?.encounter,
    encounterSummaryHtml: redux.encounter?.encounterSummaryHtml,
    encounterSummaryLoading: redux.encounter?.encounterSummaryLoading,
    encounterSummaryData: redux.encounter?.encounterSummaryData,
    patientId: redux.patient.id,
      userManagingOrg: redux?.auth?.profile?.app_metadata?.partner_organization,
      supervisor: redux?.auth?.profile?.app_metadata?.supervisor,
      medicalDirector: redux?.auth?.profile?.app_metadata?.medical_director,
    encounterSummaryForm: redux.encounterSummaryForm,
    auth: redux.auth,
    clientName,
    clientOrg,
    clientAttributes,
      settings: redux?.globalVars?.settings ?? {},
      encountersHistory: redux?.encountersHistory?.data
  }
}

export default connect(mapStateToProps)(withLegacyRouter(EncounterSummary))
